export enum DamageReportGroups {
    UNIVERSAL = 'Universal',
    LIABILITY = 'Liability',
    LUGGAGE = 'Luggage',
    TECHNICAL = 'Technical',
    PROPERTY_INSURANCE = 'PropertyInsurance',
    MOTORING = 'KFZW',
    TRANSPORT = 'Transport',
}
